import { getFirstAndLastDayOfWeek } from '../../../../../../utils/globals/date';
import { TwinDictionary } from '../../../../../../utils/globals/dictionary';
import { getEmployeeParams } from '../../../../../../utils/reducers/getters';
import { WCalTurnScheduleDictTY, WCalTurnsByEmployeeTy, WCalTurnSingleSchedule } from './types';

export const getWeekDates = (day: Date) => {
    const { end, start} = getFirstAndLastDayOfWeek(day)
    const weekDates = []
    while (start <= end) {
        weekDates.push(start.toDateString())
        start.setDate(start.getDate() + 1)
    }
    return weekDates
}

export const createDictionaryForWCalTurns = (result: TwinDictionary[], filteredWorkingCenter?: string) => {
    const myTurnsByEmployee: { [EmployeeId: number]: WCalTurnsByEmployeeTy } = {}
    const myTurnConfig = getEmployeeParams()?.['wcal_turn_config'] ?  JSON.parse(getEmployeeParams()?.['wcal_turn_config'] || '') : null
    for (const element of result) {
        const dividedByTurns: { [key: string]: WCalTurnScheduleDictTY } = {}
        const baseJourney: WCalTurnScheduleDictTY = {}
        const EmployeeId = element.employee.id
        for (const key in element?.journeys) {
            const journey = JSON.parse(JSON.stringify(element?.journeys[key]))
            const myJourney = wCalTurnParseJourney(journey)
            const myDayKey = new Date(key).toDateString()
            const isTurnDay = myJourney?.TurnId ? true : false
            baseJourney[myDayKey] = {
                ...myJourney,
                EmployeeId: element.employee.id,
                isTurnDay: isTurnDay,
            }
            if (myJourney.dividedByTurns) {
                dividedByTurns[myDayKey] = {}
                for (const turn of myJourney.dividedByTurns) {
                    const workingCenterKey = turn.WorkingCenterId || ''
                    if (!filteredWorkingCenter || !workingCenterKey || parseInt(String(workingCenterKey)) === parseInt(filteredWorkingCenter)) {
                        dividedByTurns[myDayKey][workingCenterKey] = {
                            ...myJourney,
                            schedule: { ...turn, errors: []},
                            TurnId: turn.TurnId,
                            isTurnDay: true,
                            EmployeeId: element.employee.id,
                            isBaseTurn: false
                        }
                    }
                }
            }
        }
        myTurnsByEmployee[EmployeeId] = {
            employee: element.employee,
            dividedByTurns,
            baseJourney,
            order: myTurnConfig?.order?.[EmployeeId]?.order
        }
    }
    return myTurnsByEmployee
}

const wCalTurnParseJourney = (myJourney: WCalTurnSingleSchedule) => {
    if (myJourney?.journey?.overtimePosition) {
        const workingTime = JSON.parse(JSON.stringify(myJourney.journey.workingTime))
        myJourney.originalOvertime = []
        for (const overtime of myJourney.journey.overtimePosition) {
            const hours = myJourney.journey?.workingTime[overtime]
            myJourney.originalOvertime.push(hours)
            workingTime.splice(overtime, 1)
        }
        myJourney.journey.workingTime = workingTime
    }
    return myJourney
}